

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.u98jbGqo.js","_app/immutable/chunks/scheduler.11LYO-93.js","_app/immutable/chunks/index.v-pHvQc9.js","_app/immutable/chunks/stores.ueU4tl5W.js","_app/immutable/chunks/entry.Qx6UZvYN.js"];
export const stylesheets = [];
export const fonts = [];
